import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../redux/hooks";
import { message } from "../redux/app.slice";

export const AttendanceParamsComponent = () => {
  const dispatch = useAppDispatch();

  const { method } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (method) {
      if (method === "success") {
        dispatch(
          message({
            message: "Your attendance is successfully taken.",
            severity: "success",
            open: true,
          })
        );
        navigate("/dashboard");
      }

      if (method === "error") {
        dispatch(
          message({
            message:
              "The QR code you are trying to use is invalid or has expired.",
            severity: "error",
            open: true,
          })
        );
        navigate("/dashboard/attendance");
      }
    }
  }, [method, navigate, dispatch]);

  return <></>;
};
